export const DATA_LOADING_STATE = {
  NONE: 'NONE',
  PROVISIONAL: 'PROVISIONAL',
  FULL: 'FULL',
  ERROR: 'ERROR',
};
